import { INITIAL_LOAD_REQUEST } from "../constants";

export const onInitialLoadRequest = () => ({
  type: INITIAL_LOAD_REQUEST
});
